import { breakFactTriggerSequencMap as footballBreakFactTriggerSequenceMap, liveFactTriggerSequenceMap as footballLiveFactTriggerSequenceMap, createBreakTimeline as footballCreateBreakTimeline, createLiveTimeline as footballCreateLiveTimeline } from './football/index';
import * as footballBreakTriggers from './football/triggers/break';
import * as footballLiveTriggers from './football/triggers/live';
import { breakFactTriggerSequencMap as rugbyLeagueBreakFactTriggerSequenceMap, liveFactTriggerSequenceMap as rugbyLeagueLiveFactTriggerSequenceMap, createBreakTimeline as rugbyLeagueCreateBreakTimeline, createLiveTimeline as rugbyLeagueCreateLiveTimeline } from './rugbyLeague/index';
import * as rugbyLeagueBreakTriggers from './rugbyLeague/triggers/break';
import * as rugbyLeagueLiveTriggers from './rugbyLeague/triggers/live';
export const breakFactSequenceTriggerMap = {
    football: footballBreakFactTriggerSequenceMap,
    rugbyLeague: rugbyLeagueBreakFactTriggerSequenceMap
};
export const liveFactSequenceTriggerMap = {
    football: footballLiveFactTriggerSequenceMap,
    rugbyLeague: rugbyLeagueLiveFactTriggerSequenceMap
};
export const createBreakTimeline = {
    football: footballCreateBreakTimeline,
    rugbyLeague: rugbyLeagueCreateBreakTimeline
};
export const createLiveTimeline = {
    football: footballCreateLiveTimeline,
    rugbyLeague: rugbyLeagueCreateLiveTimeline
};
export const breakTriggers = {
    football: footballBreakTriggers,
    rugbyLeague: rugbyLeagueBreakTriggers
};
export const liveTriggers = {
    football: footballLiveTriggers,
    rugbyLeague: rugbyLeagueLiveTriggers
};
//# sourceMappingURL=sequences.js.map